import React from 'react'
import { View } from 'react-native'

export default class KeyboardSpacer extends React.Component {
  render() {
    return <View />
  }
}
